/**
 * Created by hp on 2017/6/12.
 */
import React, {Component} from 'react';

import {connect} from 'react-redux'

import {toTime} from '../utils';

import '../styles/AudioPlay.css';

class AudioPlay extends Component {
    constructor() {
        super();
        this.onTogglePlay = this.onTogglePlay.bind(this);
        this.onAudioLoad = this.onAudioLoad.bind(this);
        this.onAudioTimeUpdate = this.onAudioTimeUpdate.bind(this);
        this.onPlay = this.onPlay.bind(this);
        this.onPause = this.onPause.bind(this);

        this.state = {
            isPlay: false,
            progressBarWidth: 0,
        }
    }

    onAudioLoad() {
        let audioPlay = this.refs.audioPlay,
            duration = audioPlay.duration;
        if (!isNaN(duration)) {
            this.setState({
                duration: duration,
                totalTime: toTime(duration)
            })
        }
    }

    onTogglePlay() {
        const audioPlay = this.refs.audioPlay;
        audioPlay.paused ? audioPlay.play() : audioPlay.pause();
    }

    onPlay() {
        this.setState({isPlay: true});

        this.props.dispatch({
            type: "STATS_LOG",
            payload: {
                action: 'pre_audio_click',
                ts: Date.now(),
                account_id: this.props.account_id,
                obj_type: this.props.type,
                obj_id: this.props.obj_id,
                type: this.props.type
            }
        });
    }

    onPause() {
        this.setState({isPlay: false});
    }

    onAudioTimeUpdate() {
        let audioPlay = this.refs.audioPlay;
        let {duration} = this.state;
        let currentTime = Math.min(audioPlay.currentTime, duration);
        this.handleProgress(currentTime, duration);
    }

    handleProgress(currentTime, duration) {
        let progress = (100 / duration * currentTime);
        this.setState({progressBarWidth: progress});
    }

    render() {
        const {audioUrl, title} = this.props;
        const {isPlay, totalTime, progressBarWidth} = this.state;
        return (
            <div className="box">
                <p className="weixinAudio">
                    <audio
                        ref="audioPlay"
                        preload="metadata"
                        src={audioUrl}
                        id="wk_audio_player_2"
                        width="1"
                        height="1"
                        onCanPlay={this.onAudioLoad}
                        onTimeUpdate={this.onAudioTimeUpdate}
                        onPlay={this.onPlay}
                        onPause={this.onPause}
                    />
                    <span id="audio_play_area" className={"db audio_area " + (isPlay && "playing")}
                          onClick={this.onTogglePlay}>
                        <span className="audio_wrp db">
                            <span className="audio_play_area">
                                <i className="icon_audio_default"/>
                                <i className="icon_audio_playing"/>
                            </span>
                            <span id="audio_length" className="audio_length tips_global">{totalTime}</span>
                            <span className="db audio_info_area">
                                <strong className="db audio_title">{title}</strong>
                                <span className="audio_source tips_global">点击收听音频介绍</span>
                            </span>
                            <span id="audio_progress" className="progress_bar" style={{width: progressBarWidth + "%"}}/>
                        </span>
                    </span>
                </p>
            </div>
        )
    }
}

export default connect()(AudioPlay)



// WEBPACK FOOTER //
// ./src/components/AudioPlay.js